import { InjectionToken } from '@angular/core';
import { ReportConfig } from './dtos/interfaces/report-config';
import { patronLoginAttemptsReport } from './definitions/anytime-access/patron-login-attempts.report';
import { alertHistoryReport } from './definitions/sorter/alert-history.report';
import { returnDetailsReport } from './definitions/sorter/return-details.report';
import { returnsSummaryReport } from './definitions/sorter/returns-summary.report';

export const REPORT_REGISTRY = new InjectionToken<ReportConfig[]>('REPORT_REGISTRY');

export const REPORTS: ReportConfig[] = [
    patronLoginAttemptsReport,
    alertHistoryReport,
    returnDetailsReport,
    returnsSummaryReport,
];

export const CATEGORY_ICONS: { [category: string]: string } = {
    'Anytime Access': '../../../assets/images/application-icons/Services.png',
    'Sorter':         '../../../assets/images/application-icons/Sorter.png',
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/reports/report-registry.ts